import { useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { UFOODX_BASE_URL } from "../../../utils/constants";

const VerifyRedirect = () => {
    const location = useLocation();
    const history = useHistory();

    useEffect(() => {
        const query = location.search;

        history.replace(`${UFOODX_BASE_URL}${query}`);
    }, [location, history]);

    return null;
};

export default VerifyRedirect;